"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEVELOPMENT_ANNOTO_CLIENT_ID = exports.ANNOTO_CLIENT_ID = void 0;
exports.ANNOTO_CLIENT_ID = 'eyJhbGciOiJIUzI1NiJ9.ZDEyMTdhOWEtN2QxMS00ZTBmLWIyNzctMGE4ZWUwN2M2NzQx.JWXkCOUIagc4dnrJL37lKXGqbCSBFtKdv-ktfcvCPs8';
exports.DEVELOPMENT_ANNOTO_CLIENT_ID = 'eyJhbGciOiJIUzI1NiJ9.YzY0MzM5OWUtMzg0YS00ZGU0LThiYWItNmNiYTk1MDU5ZDVk.BcW9NBSiBUsq2t0sOiFOPLehJp46YQyeTBMyho1K_A8';
//# sourceMappingURL=annoto.js.map